import React, { useEffect, useState } from 'react';
import { UserRound } from 'lucide-react';
import { resolvePhotoUrl } from '../utils/photoUrl';

// Renders a stored profile photo, or an app-controlled placeholder (never a broken-image icon).
export const PhotoPlaceholder = ({ label = 'Photo not available', className = '', compact = false }) => (
  <div
    className={`w-full h-full flex flex-col items-center justify-center bg-gradient-to-br from-rose-50 via-pink-50 to-orange-50 text-rose-300 ${className}`}
    data-testid="photo-placeholder"
  >
    <UserRound className={compact ? 'w-1/2 h-1/2' : 'w-20 h-20'} strokeWidth={1.25} />
    {!compact && <span className="mt-2 text-sm font-medium text-rose-400">{label}</span>}
  </div>
);

export const ProfilePhoto = ({ src, alt = '', className = '', compact = false, onClick, testId = 'profile-photo' }) => {
  const url = resolvePhotoUrl(src);
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [url]);

  if (!url || failed) return <PhotoPlaceholder compact={compact} className={className} />;
  return (
    <img
      src={url}
      alt={alt}
      onClick={onClick}
      onError={() => setFailed(true)}
      className={`w-full h-full object-cover ${className}`}
      data-testid={testId}
    />
  );
};

export default ProfilePhoto;
